"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGaId = void 0;
var react_cookies_1 = __importDefault(require("react-cookies"));
var getClientId = function () { var _a; return (_a = react_cookies_1.default.load('abn_test')) !== null && _a !== void 0 ? _a : 'client id is not defined'; };
/**
 * Получение clientId из Google Tag Manager
 */
var getGaId = function () {
    var clientId = react_cookies_1.default.load('_ga_cid');
    if (!clientId) {
        try {
            clientId = window.ga
                ? window.ga.getAll()[0].get('clientId')
                : getClientId();
        }
        catch (e) {
            clientId = getClientId();
        }
    }
    return clientId;
};
exports.getGaId = getGaId;
